export interface ResettableColumnApi {
  resetColumnState: () => void;
}

export interface ColumnLayoutStorage {
  removeItem: (key: string) => void;
}

/** Restore AG Grid's column definitions and remove any persisted user layout. */
export function resetColumnLayout(
  api: ResettableColumnApi,
  storageKey?: string,
  storage?: ColumnLayoutStorage,
): void {
  api.resetColumnState();

  if (!storageKey) return;
  try {
    const target = storage ?? (typeof localStorage === 'undefined' ? undefined : localStorage);
    target?.removeItem(storageKey);
  } catch {
    // Storage can be unavailable in private/restricted browser contexts.
  }
}
